import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import DefRoutes from "../../../routes/routes.json";
import useGetUser from "../../../hooks/useGetUser";
import useApi from "../../../services/api";
import { handleApiErrors } from "../../../utils/handleErrors";
import t from "../../../i18n/i18n";

import "./styles.css";
import { hasFlashPlayer } from "../../../utils/hasFlashPlayer";
import { useCallback } from "react";

export const Play = () => {
  useGetUser();
  const { logged } = useSelector((store) => store.auth);
  const { areaId } = useParams();
  const { ApiCreateLogin } = useApi();
  const [gameLink, setGameLink] = useState("");
  const [flashWarnOpen, setFlashWarnOpen] = useState(
    !hasFlashPlayer() && !localStorage.getItem("@notShowAgainFlashPlayerWarn"),
  );

  const handleCloseFlashWarn = useCallback(() => {
    localStorage.setItem("@notShowAgainFlashPlayerWarn", true);

    setFlashWarnOpen(false);
  }, []);

  useEffect(() => {
    const fetchGameLink = async () => {
      const { data } = await ApiCreateLogin({ AreaID: areaId });

      if (data.errors) {
        return handleApiErrors(data.errors);
      }

      setGameLink(data.gameLink);
    };

    if (logged) {
      fetchGameLink();
    }
  }, [ApiCreateLogin, areaId, logged]);

  if (!logged) {
    return (window.location = DefRoutes.App.SignIn);
  }
  return (
    <div className="play-container">
      {gameLink && (
        <iframe
          id="iframecontent"
          name="iframe_game_panel"
          scrolling="no"
          src={gameLink.replace("s1", "s" + areaId)}
          className="iframe-play"
          frameBorder="0"
          title="Game"
          allowfullscreen
        ></iframe>
      )}

      {flashWarnOpen && (
        <div class="container-popup" id="container-popup">
          <div class="content-popup">
            <h1>{t("Play.Modal.Title")}</h1>
            <p>{t("Play.Modal.Paragraph")}</p>
          </div>

          <div class="buttons-popup">
            <a href={t("Play.Modal.Link")} target="_blank">
              <button id="btn-download">{t("Play.Modal.Download")}</button>
            </a>
            <button id="btn-cookies" onClick={handleCloseFlashWarn}>
              {t("Play.Modal.Close")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Play;
